import { ICourse, ITee } from '../../../../../../store/admin/courses/store';

export interface ITeeOption {
  label: string;
  value: ITee;
}

interface IGetTeesOptionsArgs {
  course?: ICourse;
  gender: string | null | undefined;
}

type TGetTeesOptions = (args: IGetTeesOptionsArgs) => ITeeOption[];

export const getTeesOptions: TGetTeesOptions = args => {
  const { course, gender } = args;

  if (!course) {
    return [];
  }

  return (course.tees || [])
    .filter((tee: ITee) => tee.gender === gender || gender === 'B')
    .map((tee: ITee) => {
      const { name, par, slope, rating } = tee;

      return {
        label: `${name.toUpperCase()}, ${par}, ${slope}, ${rating}`,
        value: tee
      };
    });
};
